import KTWizard from '../../../../theme/_assets/js/wizard';
import React, { Component, useState  } from "react";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import dateFormat from 'dateformat';
import firebase from "firebase/app";
import "firebase/storage";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;


class CreatemarketCustomer extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
		// leadsId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
      "asource": "", "aCategory": "","aclientName": "", "acontactperson": "", "aphoneNumber": "",  "aLocation": "", "aCapacity": "", "aemailid": "", "aInquiredby": "", "aLeadStatus": "", "aStatus": "", "aConvertedDate": "", "aFollowupDate": "",  "aComments": "", "aFullAddress": "", "aResponsibility": "",disableSubmit: false, "aprice": ""
    };
	this.handleChange = this.handleChange.bind(this);
	this.userValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
	// const [startDate, setStartDate] = useState(new Date());  
    
  }

  modalToggle = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  toggle = () => {
    let path = "/basic-details";
    this.props.history.push({ pathname: path });
  }

	handleChange = event => {
		this.setState({profileImg: event.target.files[0]}, function () { });
 
	} 
	documenturlChange = event => {
		this.setState({contactdocumenturl: event.target.files[0]}, function () { });
	}


	handleConvertedDate = (val) => {
		this.setState({ "aConvertedDate": val });
	};
	handleFollowupDate = (val) => {
		this.setState({ "aFollowupDate": val });
	};


  handleFormFields = (event) => {
	  // console.log(event)
	switch (event.target.id) {
      case "usource":
        this.setState({ "asource": event.target.value });
        break;
      case "uCategory":
        this.setState({ "aCategory": event.target.value });
        break;
      case "uclientName":
        this.setState({ "aclientName": event.target.value });
        break;
      case "ucontactperson":
        this.setState({ "acontactperson": event.target.value });
        break;
      case "uphoneNumber":
        this.setState({ "aphoneNumber": event.target.value });
        break;
      case "uLocation":
        this.setState({ "aLocation": event.target.value });
        break;
      case "uCapacity":
        this.setState({ "aCapacity": event.target.value });
        break;
      case "uemailid":
        this.setState({ "aemailid": event.target.value });
        break;
      case "uStatus":
        this.setState({ "aStatus": event.target.value });
        break;
      case "uComments":
        this.setState({ "aComments": event.target.value });
        break;
      case "uResponsibility":
        this.setState({ "aResponsibility": event.target.value });
        break;
	 case "uPrice":
        this.setState({ "aPrice": event.target.value });
        break;
      default:
        break;
    }

  }
  
  onstatus = (event) => {
	this.setState({  "aStatus": event.target.value  })
  }
	changecategory = (event) => {
		this.setState({ "aCategory" :  event.target.value })
		
	}
	  
	createmarketlead = () => {
		if (this.userValidator.allValid()) {
			const postCustData = {
				"Source": this.state.asource,
				"Category": this.state.aCategory,
				"Client_Name": this.state.aclientName,
				"Contact_Person": this.state.acontactperson,
				"Phone_number": this.state.aphoneNumber,
				"Location": this.state.aLocation,
				"Capacity": this.state.aCapacity,
				"Email_Id": this.state.aemailid,
				"Status": this.state.aStatus,
				"Converted_Date": this.state.aConvertedDate,
				"Follow_up_Date": this.state.aFollowupDate,
				"Comments": this.state.aComments,
				"Responsibility": this.state.aResponsibility,
				"userId": this.props.userId,
				"userType": this.props.userRole,
				"userName": this.props.userName,
				"userEmail": this.props.userEmail,
				"userPhoneNumber": this.props.userPhoneNumber,
				"price": this.state.aPrice,
			}
			
		
			fetch(process.env.REACT_APP_NODE_ENV + '/api/market-target-lead/create', {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				},
				body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				.then((data) => {
					toast.success("Market Target Lead created successfully!!!", {
						position: toast.POSITION.TOP_CENTER,

					});
					 this.props.history.push({ pathname: "/market-target-lead/customer-particular-list" });
					
				}).catch((err) => console.log(err))
		} else {
			this.userValidator.showMessages();
			this.forceUpdate();
		}
	}
  

  componentDidMount() { 
	this.setState({ "aResponsibility": this.props.userName  });
  };

 

  prevStep() {
    if (this.state.percentage === 100) return;
    this.setState(prevState => ({ percentage: prevState.percentage - 20 }));
  }



  nextPath(path) {
    this.props.history.push(path);
  }



  validUserForm() {
    const { userFirstName, userLastName, userPhoneNumber, userEmail, userPassword, userConPassword } = this.state;
    let validUserFormFlag = false;
    if (userFirstName === '') {
      this.setState({ userFirstNameRequired: true });
      return validUserFormFlag;
    }
    else if (userLastName === '') {
      this.setState({ userLastNameRequired: true });
      return validUserFormFlag;
    }
    else if (userPhoneNumber === '') {
      this.setState({ userPhoneNumberRequired: true });
      return validUserFormFlag;
    }
    else if (userEmail === '') {
      this.setState({ userEmailRequired: true });
      return validUserFormFlag;
    }
    // else if (userPassword === '') {
    //   this.setState({ userPasswordRequired: true });
    //   return validUserFormFlag;
    // }
    // else if (userConPassword === '') {
    //   this.setState({ userConPasswordRequired: true });
    //   return validUserFormFlag;
    // }
    else {
      return true;
    }
  }


  render() {

    let userError = ""
    if (this.state.throwUserError) {
      userError = (<span style={{ color: "red" }}>Either Email/Phone Number Already Exist</span>)
    }
    let userForm = (<></>
    )
	

    return (<>
	
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => this.nextPath("/aprt-customer/customer-list")}
        >
         My Leads
          </Breadcrumb.Item>

        <Breadcrumb.Item active>Create Lead</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
          <Card >
            <Card.Body>
              <ModalHeader>
                Add User
                </ModalHeader>
              <ModalBody>
                {userForm}
                {userError}
              </ModalBody>
              <ModalFooter><div className="col-8 float-center">
                <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
              </div>
              </ModalFooter>
            </Card.Body>
          </Card>
        </Modal>
      </div>
      <div>
        {/* <ProgressBar
            animated
            now={this.state.percentage}
            label={`${this.state.percentage}%`}
          /> */}
      </div>
	<div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
        <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <form className="kt-form" id="kt_form" >
            <div className="kt-wizard-v1__content" >
				<div className="kt-form__section ">
					<div className="kt-wizard-v1__form ">
						<div class="panel panel-default">
							<div class="panel-body h3">Lead Information</div>
						</div>
						<br/>
						<br/>
						<div className="form-group row">
							   <div className="col-lg-5">
									<label>Source</label>
									<input type="text" className="form-control" name="asource" id="usource" placeholder="Source" value={this.state.asource} onChange={this.handleFormFields} />
								</div>
								<div className="col-lg-5">
									<label>Category *</label>
									<select name="Category" id="uCategory"  className="form-control" value={this.state.aCategory} onChange={this.changecategory} >
										<option value="">Select Category</option>
										<option value="Apartment">Apartment</option>
										<option value="Corporate">Corporate</option>
										<option value="Individual">Individual</option>
									</select>
									{
										this.userValidator.message('Category', this.state.aCategory, 'required')
									}
								</div>
							</div>
							
							<br/>
							<div class="panel panel-default">
								<div class="panel-body h5">Client Information</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-5">
									<label>Client Name *</label>
									<input type="text" className="form-control" name="aclientName" id="uclientName" placeholder="Client Name" value={this.state.aclientName} onChange={this.handleFormFields} />
									{
										this.userValidator.message('Client Name', this.state.aclientName, 'required')
									}
								 </div>
								<div className="col-lg-5">
									<label>Contact Person</label>
									<input type="text" className="form-control" name="acontactperson" id="ucontactperson" placeholder="Contact Person" value={this.state.acontactperson} onChange={this.handleFormFields} />	 
								 </div>
							</div>
							
							<div className="form-group row">
								<div className="col-lg-5">
									<label>Phone Number</label>
									<input type="text" className="form-control" name="aphoneNumber" id="uphoneNumber" placeholder="Phone Number" value={this.state.aphoneNumber} onChange={this.handleFormFields} />
								</div>
								<div className="col-lg-5">
									<label>Email Id</label>
									<input type="text" className="form-control" name="aemailid" id="uemailid" placeholder="Email Id" value={this.state.aemailid} onChange={this.handleFormFields} />
								</div>
							</div>

							<br/>
							<div class="panel panel-default">
								<div class="panel-body h5">Other Information</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-5">
									<label>Location *</label>
									<input type="text" className="form-control" name="aLocation" id="uLocation" placeholder="Location" value={this.state.aLocation} onChange={this.handleFormFields} />
									{
										this.userValidator.message('Location', this.state.aLocation, 'required')
									}
								</div>
								<div className="col-lg-5">
									<label>Capacity</label>
									<input type="text" className="form-control" name="aCapacity" id="uCapacity" placeholder="Capacity" value={this.state.aCapacity} onChange={this.handleFormFields} />
								 </div>
							</div>
							<div className="form-group row">
								<div className="col-lg-5">
									<label>Price</label>
									<input type="text" className="form-control" name="aPrice" id="uPrice" placeholder="Price" value={this.state.aPrice} onChange={this.handleFormFields} />
								</div>
							</div>
							<br/>
							<div class="panel panel-default">
								<div class="panel-body h5">Status</div>
							</div>
							
							<div className="form-group row">
								<div className="col-lg-5">
									<label>Responsibility *</label>
									<input type="text" className="form-control" name="aResponsibility" id="uResponsibility" placeholder="Responsibility" value={this.state.aResponsibility} onChange={this.handleFormFields} disabled ={"disabled"}/>
									{
										this.userValidator.message('Responsibility', this.state.aResponsibility, 'required')
									}
								 </div>
								<div className="col-lg-5">
									<label>Status *</label>
									<select name="aStatus" id="uStatus"  className="form-control" value={this.state.aStatus} onChange={this.onstatus} >
										<option value="">Select Status</option>
										<option value="Cold">Cold</option>
										<option value="Warm">Warm</option>
										<option value="Hot">Hot</option>
										<option value="Converted">Converted</option>
										<option value="Not Interested">Not Interested</option>
									</select>
									{
										this.userValidator.message('Status', this.state.aStatus, 'required')
									}
								</div>								
							</div>
							
							<div className="form-group row">
								<div className="col-lg-5" style={{display:'grid'}}>
									<label>Converted Date</label>
									<DatePicker  selected={this.state.aConvertedDate} className="form-control" name="aConvertedDate" id="uConvertedDate" placeholder="Converted Date" autoComplete="off" onSelect={this.handleConvertedDate} />
								</div>
								<div className="col-lg-5" style={{display:'grid'}}>
									<label>Follow-up Date</label>
									<DatePicker selected={this.state.aFollowupDate} className="form-control" name="aConvertedDate" id="uConvertedDate" placeholder="Follow-up Date" autoComplete="off" onSelect={this.handleFollowupDate} />
								</div>								
							</div>
							
							<br/>
							<div className="form-group row">
								<div className="col-lg-10">
									<label>Comments</label>
									 <textarea class="form-control" rows="5" id="uComments" onChange={this.handleFormFields}>{this.state.aComments}</textarea>
								</div>
							</div>
						
						
					</div>
				</div>
            </div>
			
            <div className="kt-form__actions" style={{float: "right"}}>
                <Button variant="outline-primary" onClick={() => this.createmarketlead()} style={{ margin: "0px 5px "}} > Save </Button>
                
            </div>

            {/* <!--end: Form Actions --> */}
          </form>

          {/* <!--end: Form Wizard Form--> */}
        </div>
      </div>
		
    </>
    );
  }
}


const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userName: state.auth.user[0].userFirstName+' '+state.auth.user[0].userLastName,
    userPhoneNumber: state.auth.user[0].userPhoneNumber,
    userEmail: state.auth.user[0].userEmail,
    userId: state.auth.user[0].id,
	mobiledevice: state.auth.user[0].mobiledeviceId,
  }
}

export default connect(
  mapStateToProps,
  null
)(CreatemarketCustomer)